// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextAreaProps } from "@insite/mobius/TextArea";
import { LinkPresentationProps } from "@rugby/MobiusOverrides/Link";
import formField from "@rugby/XDL/PreStyle/formField";
import { CustomMediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

export interface CheckoutGeneralStyle {
    ChangeShippingMethodButton?: LinkPresentationProps;
    notesTextAreaOneRow?: TextAreaProps;
}

const MediaQuery = CustomMediaQuery({
    sm: 420,
    md: 780,
});

export const checkoutGeneralStyle: CheckoutGeneralStyle = {
    ChangeShippingMethodButton: {
        color: "secondary",
        withIcon: true,
        typographyProps: {
            size: 15,
            css: css`
                font-weight: bold;
                letter-spacing: 0;
                line-height: 18px;
            `,
        },
    },
    notesTextAreaOneRow: {
        cssOverrides: {
            formField: css`
                width: auto;
            `,
            formInputWrapper: css`
                ${formField.defaultProps?.cssOverrides?.formInputWrapper}
                min-height: 40px;
                height: auto;
                div[data-test-selector="formField-customInputWrapper"] {
                    height: 100%;
                    width: 100%;
                }

                &&& textarea {
                    padding-bottom: 0;
                }

                textarea ~ label {
                    top: 50%;
                    transform: translateY(-50%);

                    // to prevent overlap scroll
                    width: calc(100% - 25px);
                    max-width: calc(340px - 25px);

                    ${MediaQuery.lte(340)} {
                        max-width: calc(300px - 25px);
                    }
                }
            `,
            inputSelect: css`
                ${formField.defaultProps?.cssOverrides?.inputSelect}

                height: 40px;
                width: 100%;
                max-width: 100%;
                max-height: 400px;
                min-width: 340px;
                min-height: 40px;

                resize: vertical;

                ${MediaQuery.lte("sm")} {
                    min-width: 280px;
                }

                ${MediaQuery.lte(300)} {
                    min-width: 200px;
                }
            `,
        },
    },
};
